import { render, staticRenderFns } from "./topicsList.vue?vue&type=template&id=17091d26&"
import script from "./topicsList.vue?vue&type=script&lang=js&"
export * from "./topicsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports